import { render, staticRenderFns } from "./IntroduceCategory.vue?vue&type=template&id=2a253d8e&"
import script from "./IntroduceCategory.vue?vue&type=script&lang=js&"
export * from "./IntroduceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports